import React from 'react'
import PropTypes from 'prop-types'
import { Table, TableCell, TableRow, Typography } from '@chilecompra/react-kit/components'
import { Column, Row, Section, Source } from './PartnershipCertificateDialog.styles'
import { formatPercentage } from '@chilecompra/react-kit'

/**
 * The seller and partner component.
 */
const SellerAndPartner = props => {
  const { businessName, dni, error, hasAgreement, loading, oldCertificate, partnerships, source } = props
  return (
    <Row container>
      {!oldCertificate && (
        <Column item container alignItems="flex-end">
          <Typography align="inline" color="black1" fontSize="16px" fontWeight="bold" lineHeight="20px">
            {businessName}
          </Typography>
          <Typography align="inline" color="black3" fontSize="12px" lineHeight="16px" margin="0 0 0 8px">
            {`RUT ${dni}`}
          </Typography>
        </Column>
      )}
      {partnerships.length > 0 && (
        <Table accessibility={{ label: 'Detalle Socios y Sociedades UTP' }}>
          <TableRow enableHead>
            <TableCell width="8px"> </TableCell>
            <TableCell>Socios y accionistas principales</TableCell>
            <TableCell width="50%"> Participación</TableCell>
          </TableRow>
          {partnerships.map((partnership, i) => (
            <TableRow key={partnership.dni}>
              <TableCell width="8px">{i + 1}</TableCell>
              <TableCell>{partnership.name}</TableCell>
              <TableCell width="50%">{formatPercentage(partnership.participation, 2)}</TableCell>
            </TableRow>
          ))}
        </Table>
      )}
      {partnerships.length === 0 && (
        <Row container>
          <Typography color="black3" fontSize="14px" italic lineHeight="16px" margin="12px 0" variant="subtitle">
            Sin información.
          </Typography>
        </Row>
      )}
      {!oldCertificate && partnerships.length > 0 && !error && !loading && (
        <Section margin="12px 0 48px">
          <Source>Fuente: Declaración Jurada firmada por el proveedor en Mercado Público.</Source>
        </Section>
      )}
      {oldCertificate && !error && !loading && (
        <Section margin="0 0 48px">
          {!!hasAgreement && source !== 'affidavit' && (
            <Source>
              Fuente: Diario Oficial, Ministerio de Economía, Servicio de Impuestos Internos, Registro Civil y Comisión
              para el Mercado Financiero.
            </Source>
          )}
          {!hasAgreement && source === 'affidavit' && (
            <Source>Fuente: Declaración Jurada firmada por el proveedor en Mercado Público.</Source>
          )}
          {!hasAgreement && source !== 'affidavit' && (
            <Source>Esta información estará disponible una vez aceptada la orden de compra.</Source>
          )}
        </Section>
      )}
    </Row>
  )
}

SellerAndPartner.defaultProps = {
  businessName: '',
  dni: '',
  error: false,
  hasAgreement: false,
  loading: false,
  oldCertificate: false,
  partnerships: [],
  source: ''
}

SellerAndPartner.propTypes = {
  businessName: PropTypes.string,
  dni: PropTypes.string.isRequired,
  error: PropTypes.bool,
  hasAgreement: PropTypes.bool,
  loading: PropTypes.bool,
  oldCertificate: PropTypes.bool,
  partnerships: PropTypes.arrayOf(
    PropTypes.shape({
      dni: PropTypes.string,
      personType: PropTypes.number,
      name: PropTypes.string,
      level: PropTypes.number,
      participation: PropTypes.number
    })
  ),
  source: PropTypes.string
}

export default SellerAndPartner
